
import constants from '../constants.json' assert { type: 'json' };

export const getAbtraPlayerVideosData = (contentRef) => {
    if (!contentRef) {
        return [];
    }
    const abtraVideosData = [];
    const dataWrappers = contentRef.querySelectorAll(`div[data-type="${constants.ABTRA_EDITOR.ABTRA_VIDEO_DATA_WRAPPER}"]`);
    dataWrappers.forEach(dataWrapper => {
        const videoUrl = dataWrapper.dataset.videoUrl;
        const thumbnailImageLink = dataWrapper.dataset.thumbnailImageLink;
        abtraVideosData.push({
            videoUrl,
            thumbnailImageLink,
            container: dataWrapper.parentElement,
        });
    });
    return abtraVideosData;
};